import angular from 'angular';
import template from './signup.html';
import './signup.less';

const PAGES = {
    createPassword: {
        pageName: 'createPassword',
        pageTitle: 'Create Password',
    },
    confirmPersonalInfo: {
        pageName: 'confirmPersonalInfo',
        pageTitle: 'Please confirm your name',
    }
};
class SignupController {
    constructor(SignupService) {
        'ngInject';
        this.SignupService = SignupService;
    }

    $onInit() {
        this.currentPage = PAGES.createPassword;

        this.model = {
            email: this.user.email,
            firstName: this.user.firstName,
            middleInitial: this.user.middleInitial,
            lastName: this.user.lastName,
            password: ''
        };
    }

    createPassword(event) {
        this.model.password = event.password;
        this.currentPage = PAGES.confirmPersonalInfo;
    }

    signupUser() {
        this.SignupService.signupUser(this.model)
            .then(() => {
                this.onSignup();
            });
    }

}

export const SignupComponent = {
    name: 'mmsSignup',
    component: {
        template: template,
        controller: SignupController,
        bindings: {
            userFullName: '<',
            onSignup: '&',
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/pages/signup/signup.component.js